import AccentBar from "../ui/AccentBar";
import EditableText from "../ui/EditableText";

export interface AnnouncementItem {
  label: string;
  description?: string;
}

const defaultItems: AnnouncementItem[] = [
  { label: "EU Patent from 12/2026" },
  { label: "EU Design from 09/2026" },
  { label: "DE Trademark" },
  { label: "DE Design" },
  { label: "DE Patent" },
];

interface AnnouncementsSectionProps {
  heading?: string;
  subtitle?: string;
  items?: AnnouncementItem[];
  editable?: boolean;
  onSaveHeading?: (value: string) => void;
  onSaveSubtitle?: (value: string) => void;
  onSaveItemLabel?: (index: number, value: string) => void;
  onSaveItemDescription?: (index: number, value: string) => void;
}

export default function AnnouncementsSection({
  heading = "ANNOUNCEMENTS",
  subtitle,
  items = defaultItems,
  editable = false,
  onSaveHeading,
  onSaveSubtitle,
  onSaveItemLabel,
  onSaveItemDescription,
}: AnnouncementsSectionProps) {
  return (
    <section
      className="relative overflow-hidden bg-dantzBlue bg-cover bg-center px-4 py-16 text-white md:px-8"
      style={{ backgroundImage: "url('/images/XpressIPAnnouncementBild.svg')" }}
    >
      <div className="absolute inset-0 bg-dantzBlue/50" />

      <div className="relative mx-auto max-w-4xl">
        <EditableText
          as="h2"
          value={heading}
          editMode={editable}
          onSave={(value) => onSaveHeading?.(value)}
          className="mb-3 block text-center text-[28px] font-light tracking-widest"
        />

        {subtitle && (
          <EditableText
            as="p"
            value={subtitle}
            editMode={editable}
            onSave={(value) => onSaveSubtitle?.(value)}
            className="mb-10 text-center text-base font-medium tracking-wide"
          />
        )}

        <div className="relative">
          <AccentBar position="top" />

          <div className="flex flex-col gap-8 pb-16 pt-12">
            {items.map((item, index) => (
              <div key={index}>
                {editable ? (
                  <EditableText
                    as="span"
                    value={item.label}
                    editMode
                    onSave={(value) => onSaveItemLabel?.(index, value)}
                    className="block font-medium"
                  />
                ) : (
                  <div className="font-medium">{item.label}</div>
                )}
                {item.description && (
                  editable ? (
                    <EditableText
                      as="span"
                      value={item.description}
                      editMode
                      onSave={(value) => onSaveItemDescription?.(index, value)}
                      className="mt-1 block text-sm font-light text-slate-200"
                    />
                  ) : (
                    <div className="mt-1 text-sm font-light text-slate-200">
                      {item.description}
                    </div>
                  )
                )}
              </div>
            ))}
          </div>

          <AccentBar position="bottom" rightTick />
        </div>
      </div>
    </section>
  );
}
